import { NavLinks } from './NavLinks';
import { useAuth } from '@/auth/useAuth';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Building2, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function TopBar() {
  const { manager, logout } = useAuth();
  const navigate = useNavigate();
  const hasOrganization = (manager?.organization_ids.length ?? 0) > 0;

  const initials = manager?.display_name
    ? manager.display_name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '?';

  return (
    <header className="flex h-14 items-center justify-between bg-brand-purple px-4">
      <div className="flex items-center gap-8">
        <h1 className="text-lg font-bold text-white">PathChron</h1>
        <NavLinks />
      </div>

      <div className="flex items-center gap-3">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-purple-light text-xs font-semibold text-white hover:bg-brand-purple-light/80">
              {initials}
            </span>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuGroup>
              <DropdownMenuLabel>
                <div className="text-sm font-medium">{manager?.display_name}</div>
                <div className="text-xs text-muted-foreground">{manager?.email}</div>
                <div className="mt-1 text-xs capitalize text-muted-foreground">
                  {manager?.role}
                </div>
              </DropdownMenuLabel>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            {hasOrganization && (
              <DropdownMenuItem onClick={() => navigate('/organization')}>
                <Building2 className="mr-2 h-4 w-4" />
                Organization Settings
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={logout}>
              <LogOut className="mr-2 h-4 w-4" />
              Sign Out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
